/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from "@tanstack/react-query";

import { useCallback } from "react";

import type {
    ApiResult,
    BulkSetOperationalStatusRequest,
    ChangeConfigurationTask,
    ChangeExtendedConfigurationTask,
    ChargerPayMateGetParams,
    ChargerPayMateLinkParams,
    ConnectorDto,
    CreatePassthroughChildDeviceRequest,
    DeviceAccessTagsSetRequest,
    DeviceAuthorizationDto,
    DeviceConfigurationExtendedDto,
    DeviceConfigurationItemDto,
    DeviceConnectionStatusResponse,
    DeviceConnectionStatusesParams,
    DeviceConnectorUptimeParams,
    DeviceConnectorUptimeResponse,
    DeviceDailyUptimesParams,
    DeviceDetailParams,
    DeviceDto,
    DeviceListParams,
    DeviceListReponse,
    DeviceLiveLogEnableParams,
    DeviceMaintenanceStatusLogDto,
    DeviceManagedByUpdateParams,
    DeviceParentGetParams,
    DeviceParentSetParams,
    DeviceProtocolUpdateDto,
    DeviceUptimeParams,
    DeviceUptimeResponse,
    InsertDeviceMaintenanceStatusRequest,
    PayMateConnectorAssignmentDto,
    PayMateConnectorAssignmentsResponseDto,
    PayMateTransactionDto,
    PrepareDeviceForReprovisioningParams,
    ProvisionDeviceRequest,
    ReprovisionDeviceRequest,
    SetDeviceOperationalStatusParams,
    UpdateChargerOcppConnectionParams,
    UpdateDeviceAuthorizationRequest,
    ValidateNewDeviceParams,
} from "./query.schemas";

import { useCustomFetchClient } from "./mutator/custom-fetch";
import type { ErrorType, BodyType } from "./mutator/custom-fetch";

/**
 * Obsolete, use DeviceConfigurationUpdate task api. Set Device configuration. Requires user to have IlluminateAdmin access tag
 * @deprecated
 */
export const useDeviceConfigurationSetHook = () => {
    const deviceConfigurationSet =
        useCustomFetchClient<DeviceConfigurationItemDto[]>();

    return useCallback(
        (
            deviceIdentity: string,
            deviceConfigurationItemDto?: BodyType<DeviceConfigurationItemDto[]>,
            signal?: AbortSignal,
        ) => {
            return deviceConfigurationSet({
                url: `/devices/${deviceIdentity}/configuration`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: deviceConfigurationItemDto,
                signal,
            });
        },
        [deviceConfigurationSet],
    );
};

export const useDeviceConfigurationSetMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationSetHook>>>,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<DeviceConfigurationItemDto[]>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationSetHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceConfigurationItemDto[]> },
    TContext
> => {
    const mutationKey = ["deviceConfigurationSet"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceConfigurationSet = useDeviceConfigurationSetHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationSetHook>>>,
        {
            deviceIdentity: string;
            data?: BodyType<DeviceConfigurationItemDto[]>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceConfigurationSet(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceConfigurationSetMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationSetHook>>>
>;
export type DeviceConfigurationSetMutationBody =
    | BodyType<DeviceConfigurationItemDto[]>
    | undefined;
export type DeviceConfigurationSetMutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useDeviceConfigurationSet = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceConfigurationSetHook>>
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<DeviceConfigurationItemDto[]>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationSetHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceConfigurationItemDto[]> },
    TContext
> => {
    return useMutation(
        useDeviceConfigurationSetMutationOptions(options),
        queryClient,
    );
};
/**
 * Set (or add if not exist) device configuration item. Will return a taskId if device is online, else will update db. Admin only.
 */
export const useDeviceConfigurationUpdateHook = () => {
    const deviceConfigurationUpdate = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            changeConfigurationTask?: BodyType<ChangeConfigurationTask>,
            signal?: AbortSignal,
        ) => {
            return deviceConfigurationUpdate({
                url: `/devices/${deviceIdentity}/configuration`,
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                data: changeConfigurationTask,
                signal,
            });
        },
        [deviceConfigurationUpdate],
    );
};

export const useDeviceConfigurationUpdateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceConfigurationUpdateHook>>
        >,
        TError,
        { deviceIdentity: string; data?: BodyType<ChangeConfigurationTask> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationUpdateHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<ChangeConfigurationTask> },
    TContext
> => {
    const mutationKey = ["deviceConfigurationUpdate"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceConfigurationUpdate = useDeviceConfigurationUpdateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceConfigurationUpdateHook>>
        >,
        { deviceIdentity: string; data?: BodyType<ChangeConfigurationTask> }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceConfigurationUpdate(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceConfigurationUpdateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationUpdateHook>>>
>;
export type DeviceConfigurationUpdateMutationBody =
    | BodyType<ChangeConfigurationTask>
    | undefined;
export type DeviceConfigurationUpdateMutationError = ErrorType<unknown>;

export const useDeviceConfigurationUpdate = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceConfigurationUpdateHook>>
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<ChangeConfigurationTask>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceConfigurationUpdateHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<ChangeConfigurationTask> },
    TContext
> => {
    return useMutation(
        useDeviceConfigurationUpdateMutationOptions(options),
        queryClient,
    );
};
/**
 * An OData endpoint that lists devices that are assignable to the provided device group. If the group is an org, returns only devices not in an org. If the group is a Site, returns only devices in the org and not in a Site. Else, if the group has an org, returns only devices in the org (even if caller is admin). Endpoint also ensures you have permission to assign devices to this group.
 */
export const useDeviceListForGroupAssignmentODataHook = () => {
    const deviceListForGroupAssignmentOData =
        useCustomFetchClient<DeviceDto[]>();

    return useCallback(
        (deviceGroupTag: string, signal?: AbortSignal) => {
            return deviceListForGroupAssignmentOData({
                url: `/device-groups/${deviceGroupTag}/devices-for-assignment-odata`,
                method: "GET",
                signal,
            });
        },
        [deviceListForGroupAssignmentOData],
    );
};

export const getDeviceListForGroupAssignmentODataQueryKey = (
    deviceGroupTag: string,
) => {
    return [
        `/device-groups/${deviceGroupTag}/devices-for-assignment-odata`,
    ] as const;
};

export const useDeviceListForGroupAssignmentODataQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceListForGroupAssignmentODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceListForGroupAssignmentODataHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceListForGroupAssignmentODataQueryKey(deviceGroupTag);

    const deviceListForGroupAssignmentOData =
        useDeviceListForGroupAssignmentODataHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeviceListForGroupAssignmentODataHook>
            >
        >
    > = ({ signal }) =>
        deviceListForGroupAssignmentOData(deviceGroupTag, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceGroupTag,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeviceListForGroupAssignmentODataHook>
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceListForGroupAssignmentODataQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useDeviceListForGroupAssignmentODataHook>>
    >
>;
export type DeviceListForGroupAssignmentODataQueryError = ErrorType<unknown>;

export function useDeviceListForGroupAssignmentOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceListForGroupAssignmentODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceListForGroupAssignmentODataHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceListForGroupAssignmentODataHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceListForGroupAssignmentODataHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceListForGroupAssignmentOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceListForGroupAssignmentODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceListForGroupAssignmentODataHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceListForGroupAssignmentODataHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceListForGroupAssignmentODataHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceListForGroupAssignmentOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceListForGroupAssignmentODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceListForGroupAssignmentODataHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceListForGroupAssignmentOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceListForGroupAssignmentODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceListForGroupAssignmentODataHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceListForGroupAssignmentODataQueryOptions(
        deviceGroupTag,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List devices visible for the current IlluminateUser's accessTags. Supports paging
 */
export const useDeviceListHook = () => {
    const deviceList = useCustomFetchClient<DeviceListReponse>();

    return useCallback(
        (params?: DeviceListParams, signal?: AbortSignal) => {
            return deviceList({
                url: `/devices`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceList],
    );
};

export const getDeviceListQueryKey = (params?: DeviceListParams) => {
    return [`/devices`, ...(params ? [params] : [])] as const;
};

export const useDeviceListQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: DeviceListParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getDeviceListQueryKey(params);

    const deviceList = useDeviceListHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>
    > = ({ signal }) => deviceList(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceListQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>
>;
export type DeviceListQueryError = ErrorType<unknown>;

export function useDeviceList<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
    TError = ErrorType<unknown>,
>(
    params: undefined | DeviceListParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceList<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: DeviceListParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceList<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: DeviceListParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceList<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: DeviceListParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceListQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Insert (provision) a new device. If successful, device has been inserted to db and org assigned. Requires one of device_provisioning, partner_device_provisioning, system_device_provisioning permission. Can then use DeviceParentSet (same permissions), SetDeviceOwner (system_device_provisioning), DeviceAccessTagsSet (system_device_access_tags_update), DeviceGroupMapDevices (user: device_group_manage, partner: partner_device_provisioning, staff: system_device_provisioning), DeviceAuthorizationUpdate (device_passthrough_manage), DeviceConfigurationUpdate (device_config_update) APIs as needed to set access
 */
export const useDeviceProvisionHook = () => {
    const deviceProvision = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            provisionDeviceRequest?: BodyType<ProvisionDeviceRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceProvision({
                url: `/devices`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: provisionDeviceRequest,
                signal,
            });
        },
        [deviceProvision],
    );
};

export const useDeviceProvisionMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceProvisionHook>>>,
        TError,
        { data?: BodyType<ProvisionDeviceRequest> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceProvisionHook>>>,
    TError,
    { data?: BodyType<ProvisionDeviceRequest> },
    TContext
> => {
    const mutationKey = ["deviceProvision"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceProvision = useDeviceProvisionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceProvisionHook>>>,
        { data?: BodyType<ProvisionDeviceRequest> }
    > = (props) => {
        const { data } = props ?? {};

        return deviceProvision(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceProvisionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceProvisionHook>>>
>;
export type DeviceProvisionMutationBody =
    | BodyType<ProvisionDeviceRequest>
    | undefined;
export type DeviceProvisionMutationError = ErrorType<unknown>;

export const useDeviceProvision = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceProvisionHook>>>,
            TError,
            { data?: BodyType<ProvisionDeviceRequest> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceProvisionHook>>>,
    TError,
    { data?: BodyType<ProvisionDeviceRequest> },
    TContext
> => {
    return useMutation(useDeviceProvisionMutationOptions(options), queryClient);
};
/**
 * An OData endpoint that lists devices visible for the current IlluminateUser. Pass an 'advancedSearch' OData filter parameter to search across other fields (config item values (if device_config_read), Vendor, InternalNotes (if staff), DeviceAddress (if device_location_read)); eg $filter=contains(tolower(advancedSearch),'offered').
 */
export const useDeviceListODataHook = () => {
    const deviceListOData = useCustomFetchClient<DeviceDto[]>();

    return useCallback(
        (signal?: AbortSignal) => {
            return deviceListOData({
                url: `/devices-odata`,
                method: "GET",
                signal,
            });
        },
        [deviceListOData],
    );
};

export const getDeviceListODataQueryKey = () => {
    return [`/devices-odata`] as const;
};

export const useDeviceListODataQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getDeviceListODataQueryKey();

    const deviceListOData = useDeviceListODataHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>
    > = ({ signal }) => deviceListOData(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceListODataQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>
>;
export type DeviceListODataQueryError = ErrorType<unknown>;

export function useDeviceListOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceListODataHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceListODataHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceListOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceListODataHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceListODataHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceListOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceListOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceListODataHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceListODataQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * An OData endpoint for querying device data, including uptime. Supports query options such as filtering, sorting, and paging for efficient data management.
 */
export const useUptimeDeviceListODataHook = () => {
    const uptimeDeviceListOData = useCustomFetchClient<DeviceDto[]>();

    return useCallback(
        (signal?: AbortSignal) => {
            return uptimeDeviceListOData({
                url: `/uptime-devices-odata`,
                method: "GET",
                signal,
            });
        },
        [uptimeDeviceListOData],
    );
};

export const getUptimeDeviceListODataQueryKey = () => {
    return [`/uptime-devices-odata`] as const;
};

export const useUptimeDeviceListODataQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
            >,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getUptimeDeviceListODataQueryKey();

    const uptimeDeviceListOData = useUptimeDeviceListODataHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>>
    > = ({ signal }) => uptimeDeviceListOData(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UptimeDeviceListODataQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>>
>;
export type UptimeDeviceListODataQueryError = ErrorType<unknown>;

export function useUptimeDeviceListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useUptimeDeviceListODataHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useUptimeDeviceListODataHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUptimeDeviceListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useUptimeDeviceListODataHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useUptimeDeviceListODataHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUptimeDeviceListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUptimeDeviceListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useUptimeDeviceListODataHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useUptimeDeviceListODataQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Device details
 */
export const useDeviceDetailHook = () => {
    const deviceDetail = useCustomFetchClient<DeviceDto>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceDetailParams,
            signal?: AbortSignal,
        ) => {
            return deviceDetail({
                url: `/devices/${deviceIdentity}`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceDetail],
    );
};

export const getDeviceDetailQueryKey = (
    deviceIdentity: string,
    params?: DeviceDetailParams,
) => {
    return [`/devices/${deviceIdentity}`, ...(params ? [params] : [])] as const;
};

export const useDeviceDetailQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDetailParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceDetailQueryKey(deviceIdentity, params);

    const deviceDetail = useDeviceDetailHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>
    > = ({ signal }) => deviceDetail(deviceIdentity, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceDetailQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>
>;
export type DeviceDetailQueryError = ErrorType<unknown>;

export function useDeviceDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params: undefined | DeviceDetailParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDetailParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDetailParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDetailParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceDetailHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceDetailQueryOptions(
        deviceIdentity,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Archive a device. If this is a virtual passthrough, soft resets the parent device (if online). Requires system_device_deprovisioning permission.
 */
export const useDeviceArchiveHook = () => {
    const deviceArchive = useCustomFetchClient<ApiResult>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceArchive({
                url: `/devices/${deviceIdentity}`,
                method: "DELETE",
                signal,
            });
        },
        [deviceArchive],
    );
};

export const useDeviceArchiveMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceArchiveHook>>>,
        TError,
        { deviceIdentity: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceArchiveHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    const mutationKey = ["deviceArchive"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceArchive = useDeviceArchiveHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceArchiveHook>>>,
        { deviceIdentity: string }
    > = (props) => {
        const { deviceIdentity } = props ?? {};

        return deviceArchive(deviceIdentity);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceArchiveMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceArchiveHook>>>
>;

export type DeviceArchiveMutationError = ErrorType<unknown>;

export const useDeviceArchive = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceArchiveHook>>>,
            TError,
            { deviceIdentity: string },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceArchiveHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    return useMutation(useDeviceArchiveMutationOptions(options), queryClient);
};
/**
 * Update location. Includes lat/lng, address, friendlyName, timeZone.
 */
export const useDeviceLocationSetHook = () => {
    const deviceLocationSet = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            deviceDto?: BodyType<DeviceDto>,
            signal?: AbortSignal,
        ) => {
            return deviceLocationSet({
                url: `/devices/${deviceIdentity}/location`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: deviceDto,
                signal,
            });
        },
        [deviceLocationSet],
    );
};

export const useDeviceLocationSetMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceLocationSetHook>>>,
        TError,
        { deviceIdentity: string; data?: BodyType<DeviceDto> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceLocationSetHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceDto> },
    TContext
> => {
    const mutationKey = ["deviceLocationSet"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceLocationSet = useDeviceLocationSetHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceLocationSetHook>>>,
        { deviceIdentity: string; data?: BodyType<DeviceDto> }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceLocationSet(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceLocationSetMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceLocationSetHook>>>
>;
export type DeviceLocationSetMutationBody = BodyType<DeviceDto> | undefined;
export type DeviceLocationSetMutationError = ErrorType<unknown>;

export const useDeviceLocationSet = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceLocationSetHook>>>,
            TError,
            { deviceIdentity: string; data?: BodyType<DeviceDto> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceLocationSetHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceDto> },
    TContext
> => {
    return useMutation(
        useDeviceLocationSetMutationOptions(options),
        queryClient,
    );
};
/**
 * Set Device Access Tags. Requires user to have IlluminateAdmin access tag
 */
export const useDeviceAccessTagsSetHook = () => {
    const deviceAccessTagsSet = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            deviceAccessTagsSetRequest?: BodyType<DeviceAccessTagsSetRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceAccessTagsSet({
                url: `/devices/${deviceIdentity}/access-tags`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: deviceAccessTagsSetRequest,
                signal,
            });
        },
        [deviceAccessTagsSet],
    );
};

export const useDeviceAccessTagsSetMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceAccessTagsSetHook>>>,
        TError,
        { deviceIdentity: string; data?: BodyType<DeviceAccessTagsSetRequest> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceAccessTagsSetHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceAccessTagsSetRequest> },
    TContext
> => {
    const mutationKey = ["deviceAccessTagsSet"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceAccessTagsSet = useDeviceAccessTagsSetHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceAccessTagsSetHook>>>,
        { deviceIdentity: string; data?: BodyType<DeviceAccessTagsSetRequest> }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceAccessTagsSet(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceAccessTagsSetMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceAccessTagsSetHook>>>
>;
export type DeviceAccessTagsSetMutationBody =
    | BodyType<DeviceAccessTagsSetRequest>
    | undefined;
export type DeviceAccessTagsSetMutationError = ErrorType<unknown>;

export const useDeviceAccessTagsSet = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceAccessTagsSetHook>>>,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<DeviceAccessTagsSetRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceAccessTagsSetHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceAccessTagsSetRequest> },
    TContext
> => {
    return useMutation(
        useDeviceAccessTagsSetMutationOptions(options),
        queryClient,
    );
};
/**
 * Get device's parent, or 404 if none
 */
export const useDeviceParentGetHook = () => {
    const deviceParentGet = useCustomFetchClient<DeviceDto>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceParentGetParams,
            signal?: AbortSignal,
        ) => {
            return deviceParentGet({
                url: `/devices/${deviceIdentity}/parent`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceParentGet],
    );
};

export const getDeviceParentGetQueryKey = (
    deviceIdentity: string,
    params?: DeviceParentGetParams,
) => {
    return [
        `/devices/${deviceIdentity}/parent`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceParentGetQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceParentGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceParentGetQueryKey(deviceIdentity, params);

    const deviceParentGet = useDeviceParentGetHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>
    > = ({ signal }) => deviceParentGet(deviceIdentity, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceParentGetQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>
>;
export type DeviceParentGetQueryError = ErrorType<unknown>;

export function useDeviceParentGet<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params: undefined | DeviceParentGetParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceParentGetHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceParentGetHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceParentGet<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceParentGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceParentGetHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceParentGetHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceParentGet<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceParentGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceParentGet<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceParentGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceParentGetHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceParentGetQueryOptions(
        deviceIdentity,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Set or remove device's parent. Requires one of device_provisioning, partner_device_provisioning, system_device_provisioning permission.
 */
export const useDeviceParentSetHook = () => {
    const deviceParentSet = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceParentSetParams,
            signal?: AbortSignal,
        ) => {
            return deviceParentSet({
                url: `/devices/${deviceIdentity}/parent`,
                method: "PUT",
                params,
                signal,
            });
        },
        [deviceParentSet],
    );
};

export const useDeviceParentSetMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceParentSetHook>>>,
        TError,
        { deviceIdentity: string; params?: DeviceParentSetParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceParentSetHook>>>,
    TError,
    { deviceIdentity: string; params?: DeviceParentSetParams },
    TContext
> => {
    const mutationKey = ["deviceParentSet"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceParentSet = useDeviceParentSetHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceParentSetHook>>>,
        { deviceIdentity: string; params?: DeviceParentSetParams }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return deviceParentSet(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceParentSetMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceParentSetHook>>>
>;

export type DeviceParentSetMutationError = ErrorType<unknown>;

export const useDeviceParentSet = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceParentSetHook>>>,
            TError,
            { deviceIdentity: string; params?: DeviceParentSetParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceParentSetHook>>>,
    TError,
    { deviceIdentity: string; params?: DeviceParentSetParams },
    TContext
> => {
    return useMutation(useDeviceParentSetMutationOptions(options), queryClient);
};
/**
 * Get charger's linked PayMate, or 404 if none
 */
export const useChargerPayMateGetHook = () => {
    const chargerPayMateGet = useCustomFetchClient<DeviceDto>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: ChargerPayMateGetParams,
            signal?: AbortSignal,
        ) => {
            return chargerPayMateGet({
                url: `/devices/${deviceIdentity}/paymate`,
                method: "GET",
                params,
                signal,
            });
        },
        [chargerPayMateGet],
    );
};

export const getChargerPayMateGetQueryKey = (
    deviceIdentity: string,
    params?: ChargerPayMateGetParams,
) => {
    return [
        `/devices/${deviceIdentity}/paymate`,
        ...(params ? [params] : []),
    ] as const;
};

export const useChargerPayMateGetQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: ChargerPayMateGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getChargerPayMateGetQueryKey(deviceIdentity, params);

    const chargerPayMateGet = useChargerPayMateGetHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>
    > = ({ signal }) => chargerPayMateGet(deviceIdentity, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChargerPayMateGetQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>
>;
export type ChargerPayMateGetQueryError = ErrorType<unknown>;

export function useChargerPayMateGet<
    TData = Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params: undefined | ChargerPayMateGetParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChargerPayMateGet<
    TData = Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: ChargerPayMateGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChargerPayMateGet<
    TData = Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: ChargerPayMateGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useChargerPayMateGet<
    TData = Awaited<ReturnType<ReturnType<typeof useChargerPayMateGetHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: ChargerPayMateGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useChargerPayMateGetHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useChargerPayMateGetQueryOptions(
        deviceIdentity,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Link or unlink a charger to a PayMate
 */
export const useChargerPayMateLinkHook = () => {
    const chargerPayMateLink = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: ChargerPayMateLinkParams,
            signal?: AbortSignal,
        ) => {
            return chargerPayMateLink({
                url: `/devices/${deviceIdentity}/paymate`,
                method: "PUT",
                params,
                signal,
            });
        },
        [chargerPayMateLink],
    );
};

export const useChargerPayMateLinkMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useChargerPayMateLinkHook>>>,
        TError,
        { deviceIdentity: string; params?: ChargerPayMateLinkParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useChargerPayMateLinkHook>>>,
    TError,
    { deviceIdentity: string; params?: ChargerPayMateLinkParams },
    TContext
> => {
    const mutationKey = ["chargerPayMateLink"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const chargerPayMateLink = useChargerPayMateLinkHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useChargerPayMateLinkHook>>>,
        { deviceIdentity: string; params?: ChargerPayMateLinkParams }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return chargerPayMateLink(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type ChargerPayMateLinkMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useChargerPayMateLinkHook>>>
>;

export type ChargerPayMateLinkMutationError = ErrorType<unknown>;

export const useChargerPayMateLink = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useChargerPayMateLinkHook>>>,
            TError,
            { deviceIdentity: string; params?: ChargerPayMateLinkParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useChargerPayMateLinkHook>>>,
    TError,
    { deviceIdentity: string; params?: ChargerPayMateLinkParams },
    TContext
> => {
    return useMutation(
        useChargerPayMateLinkMutationOptions(options),
        queryClient,
    );
};
/**
 * Every connector of the charger with the PayMate (if any) that sells it, plus whether the charger's connectors are split across multiple child PayMate terminals (hasChildPayMates=true) or served by a single linked PayMate.
 */
export const useChargerPayMateConnectorAssignmentsGetHook = () => {
    const chargerPayMateConnectorAssignmentsGet =
        useCustomFetchClient<PayMateConnectorAssignmentsResponseDto>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return chargerPayMateConnectorAssignmentsGet({
                url: `/devices/${deviceIdentity}/paymate/connector-assignments`,
                method: "GET",
                signal,
            });
        },
        [chargerPayMateConnectorAssignmentsGet],
    );
};

export const getChargerPayMateConnectorAssignmentsGetQueryKey = (
    deviceIdentity: string,
) => {
    return [
        `/devices/${deviceIdentity}/paymate/connector-assignments`,
    ] as const;
};

export const useChargerPayMateConnectorAssignmentsGetQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
        >
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useChargerPayMateConnectorAssignmentsGetHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getChargerPayMateConnectorAssignmentsGetQueryKey(deviceIdentity);

    const chargerPayMateConnectorAssignmentsGet =
        useChargerPayMateConnectorAssignmentsGetHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
            >
        >
    > = ({ signal }) =>
        chargerPayMateConnectorAssignmentsGet(deviceIdentity, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChargerPayMateConnectorAssignmentsGetQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
        >
    >
>;
export type ChargerPayMateConnectorAssignmentsGetQueryError =
    ErrorType<unknown>;

export function useChargerPayMateConnectorAssignmentsGet<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
        >
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useChargerPayMateConnectorAssignmentsGetHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useChargerPayMateConnectorAssignmentsGetHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useChargerPayMateConnectorAssignmentsGetHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChargerPayMateConnectorAssignmentsGet<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
        >
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useChargerPayMateConnectorAssignmentsGetHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useChargerPayMateConnectorAssignmentsGetHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useChargerPayMateConnectorAssignmentsGetHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChargerPayMateConnectorAssignmentsGet<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
        >
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useChargerPayMateConnectorAssignmentsGetHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useChargerPayMateConnectorAssignmentsGet<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsGetHook>
        >
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useChargerPayMateConnectorAssignmentsGetHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useChargerPayMateConnectorAssignmentsGetQueryOptions(
        deviceIdentity,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Full-replace of the charger's per-connector PayMate assignments (parent/child PayMates). Each assigned PayMate must be a child of the charger's linked (parent) PayMate. An empty array clears all assignments; connectors without an entry are not sold by any terminal. Affected terminals are soft-reset to re-pull their configs. Requires system_device_provisioning permission.
 */
export const useChargerPayMateConnectorAssignmentsSetHook = () => {
    const chargerPayMateConnectorAssignmentsSet =
        useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            payMateConnectorAssignmentDto?: BodyType<
                PayMateConnectorAssignmentDto[]
            >,
            signal?: AbortSignal,
        ) => {
            return chargerPayMateConnectorAssignmentsSet({
                url: `/devices/${deviceIdentity}/paymate/connector-assignments`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: payMateConnectorAssignmentDto,
                signal,
            });
        },
        [chargerPayMateConnectorAssignmentsSet],
    );
};

export const useChargerPayMateConnectorAssignmentsSetMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useChargerPayMateConnectorAssignmentsSetHook>
            >
        >,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<PayMateConnectorAssignmentDto[]>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsSetHook>
        >
    >,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<PayMateConnectorAssignmentDto[]>;
    },
    TContext
> => {
    const mutationKey = ["chargerPayMateConnectorAssignmentsSet"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const chargerPayMateConnectorAssignmentsSet =
        useChargerPayMateConnectorAssignmentsSetHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useChargerPayMateConnectorAssignmentsSetHook>
            >
        >,
        {
            deviceIdentity: string;
            data?: BodyType<PayMateConnectorAssignmentDto[]>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return chargerPayMateConnectorAssignmentsSet(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ChargerPayMateConnectorAssignmentsSetMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsSetHook>
        >
    >
>;
export type ChargerPayMateConnectorAssignmentsSetMutationBody =
    | BodyType<PayMateConnectorAssignmentDto[]>
    | undefined;
export type ChargerPayMateConnectorAssignmentsSetMutationError =
    ErrorType<unknown>;

export const useChargerPayMateConnectorAssignmentsSet = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useChargerPayMateConnectorAssignmentsSetHook
                    >
                >
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<PayMateConnectorAssignmentDto[]>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof useChargerPayMateConnectorAssignmentsSetHook>
        >
    >,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<PayMateConnectorAssignmentDto[]>;
    },
    TContext
> => {
    return useMutation(
        useChargerPayMateConnectorAssignmentsSetMutationOptions(options),
        queryClient,
    );
};
/**
 * Retrieve device extended configuration.
 */
export const useDeviceExtendedConfigurationGetHook = () => {
    const deviceExtendedConfigurationGet =
        useCustomFetchClient<DeviceConfigurationExtendedDto>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceExtendedConfigurationGet({
                url: `/devices/${deviceIdentity}/configuration-extended`,
                method: "GET",
                signal,
            });
        },
        [deviceExtendedConfigurationGet],
    );
};

export const getDeviceExtendedConfigurationGetQueryKey = (
    deviceIdentity: string,
) => {
    return [`/devices/${deviceIdentity}/configuration-extended`] as const;
};

export const useDeviceExtendedConfigurationGetQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceExtendedConfigurationGetHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceExtendedConfigurationGetQueryKey(deviceIdentity);

    const deviceExtendedConfigurationGet =
        useDeviceExtendedConfigurationGetHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
        >
    > = ({ signal }) => deviceExtendedConfigurationGet(deviceIdentity, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceExtendedConfigurationGetQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
    >
>;
export type DeviceExtendedConfigurationGetQueryError = ErrorType<unknown>;

export function useDeviceExtendedConfigurationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceExtendedConfigurationGetHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceExtendedConfigurationGetHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceExtendedConfigurationGetHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceExtendedConfigurationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceExtendedConfigurationGetHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceExtendedConfigurationGetHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceExtendedConfigurationGetHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceExtendedConfigurationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceExtendedConfigurationGetHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceExtendedConfigurationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceExtendedConfigurationGetHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceExtendedConfigurationGetQueryOptions(
        deviceIdentity,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Set (or add if not exist) device extended configuration item. Will return a taskId if device is online, else will update db. Admin only.
 */
export const useDeviceExtendedConfigurationUpdateHook = () => {
    const deviceExtendedConfigurationUpdate = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            changeExtendedConfigurationTask?: BodyType<ChangeExtendedConfigurationTask>,
            signal?: AbortSignal,
        ) => {
            return deviceExtendedConfigurationUpdate({
                url: `/devices/${deviceIdentity}/configuration-extended`,
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                data: changeExtendedConfigurationTask,
                signal,
            });
        },
        [deviceExtendedConfigurationUpdate],
    );
};

export const useDeviceExtendedConfigurationUpdateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeviceExtendedConfigurationUpdateHook>
            >
        >,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<ChangeExtendedConfigurationTask>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationUpdateHook>>
    >,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<ChangeExtendedConfigurationTask>;
    },
    TContext
> => {
    const mutationKey = ["deviceExtendedConfigurationUpdate"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceExtendedConfigurationUpdate =
        useDeviceExtendedConfigurationUpdateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeviceExtendedConfigurationUpdateHook>
            >
        >,
        {
            deviceIdentity: string;
            data?: BodyType<ChangeExtendedConfigurationTask>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceExtendedConfigurationUpdate(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceExtendedConfigurationUpdateMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationUpdateHook>>
    >
>;
export type DeviceExtendedConfigurationUpdateMutationBody =
    | BodyType<ChangeExtendedConfigurationTask>
    | undefined;
export type DeviceExtendedConfigurationUpdateMutationError = ErrorType<unknown>;

export const useDeviceExtendedConfigurationUpdate = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useDeviceExtendedConfigurationUpdateHook>
                >
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<ChangeExtendedConfigurationTask>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof useDeviceExtendedConfigurationUpdateHook>>
    >,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<ChangeExtendedConfigurationTask>;
    },
    TContext
> => {
    return useMutation(
        useDeviceExtendedConfigurationUpdateMutationOptions(options),
        queryClient,
    );
};
/**
 * Begin live logging for a device. Admin only. Client must also call signalRHub.invoke('joinGroup', `device_<deviceId>`), and listen to it via `signalRHub.on('deviceLiveLogUpdateMessage', (message: DeviceLiveLogUpdateSrm) => {}` to receive messages.
 */
export const useDeviceLiveLogEnableHook = () => {
    const deviceLiveLogEnable = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceLiveLogEnableParams,
            signal?: AbortSignal,
        ) => {
            return deviceLiveLogEnable({
                url: `/devices/${deviceIdentity}/live-logging`,
                method: "PUT",
                params,
                signal,
            });
        },
        [deviceLiveLogEnable],
    );
};

export const useDeviceLiveLogEnableMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceLiveLogEnableHook>>>,
        TError,
        { deviceIdentity: string; params?: DeviceLiveLogEnableParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceLiveLogEnableHook>>>,
    TError,
    { deviceIdentity: string; params?: DeviceLiveLogEnableParams },
    TContext
> => {
    const mutationKey = ["deviceLiveLogEnable"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceLiveLogEnable = useDeviceLiveLogEnableHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceLiveLogEnableHook>>>,
        { deviceIdentity: string; params?: DeviceLiveLogEnableParams }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return deviceLiveLogEnable(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceLiveLogEnableMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceLiveLogEnableHook>>>
>;

export type DeviceLiveLogEnableMutationError = ErrorType<unknown>;

export const useDeviceLiveLogEnable = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceLiveLogEnableHook>>>,
            TError,
            { deviceIdentity: string; params?: DeviceLiveLogEnableParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceLiveLogEnableHook>>>,
    TError,
    { deviceIdentity: string; params?: DeviceLiveLogEnableParams },
    TContext
> => {
    return useMutation(
        useDeviceLiveLogEnableMutationOptions(options),
        queryClient,
    );
};
/**
 * Set operational at for a device. Requires device_operational_update permission.
 */
export const useSetDeviceOperationalStatusHook = () => {
    const setDeviceOperationalStatus = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: SetDeviceOperationalStatusParams,
            signal?: AbortSignal,
        ) => {
            return setDeviceOperationalStatus({
                url: `/devices/${deviceIdentity}/operational-status`,
                method: "PUT",
                params,
                signal,
            });
        },
        [setDeviceOperationalStatus],
    );
};

export const useSetDeviceOperationalStatusMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useSetDeviceOperationalStatusHook>>
        >,
        TError,
        { deviceIdentity: string; params?: SetDeviceOperationalStatusParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSetDeviceOperationalStatusHook>>>,
    TError,
    { deviceIdentity: string; params?: SetDeviceOperationalStatusParams },
    TContext
> => {
    const mutationKey = ["setDeviceOperationalStatus"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const setDeviceOperationalStatus = useSetDeviceOperationalStatusHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useSetDeviceOperationalStatusHook>>
        >,
        { deviceIdentity: string; params?: SetDeviceOperationalStatusParams }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return setDeviceOperationalStatus(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetDeviceOperationalStatusMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSetDeviceOperationalStatusHook>>>
>;

export type SetDeviceOperationalStatusMutationError = ErrorType<unknown>;

export const useSetDeviceOperationalStatus = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useSetDeviceOperationalStatusHook>>
            >,
            TError,
            {
                deviceIdentity: string;
                params?: SetDeviceOperationalStatusParams;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSetDeviceOperationalStatusHook>>>,
    TError,
    { deviceIdentity: string; params?: SetDeviceOperationalStatusParams },
    TContext
> => {
    return useMutation(
        useSetDeviceOperationalStatusMutationOptions(options),
        queryClient,
    );
};
/**
 * Set operational at for a list of devices. Requires device_operational_update permission.
 */
export const useBulkSetDeviceOperationalStatusHook = () => {
    const bulkSetDeviceOperationalStatus = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            bulkSetOperationalStatusRequest?: BodyType<BulkSetOperationalStatusRequest>,
            signal?: AbortSignal,
        ) => {
            return bulkSetDeviceOperationalStatus({
                url: `/devices/bulk-operational-status`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: bulkSetOperationalStatusRequest,
                signal,
            });
        },
        [bulkSetDeviceOperationalStatus],
    );
};

export const useBulkSetDeviceOperationalStatusMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useBulkSetDeviceOperationalStatusHook>>
        >,
        TError,
        { data?: BodyType<BulkSetOperationalStatusRequest> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof useBulkSetDeviceOperationalStatusHook>>
    >,
    TError,
    { data?: BodyType<BulkSetOperationalStatusRequest> },
    TContext
> => {
    const mutationKey = ["bulkSetDeviceOperationalStatus"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const bulkSetDeviceOperationalStatus =
        useBulkSetDeviceOperationalStatusHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useBulkSetDeviceOperationalStatusHook>>
        >,
        { data?: BodyType<BulkSetOperationalStatusRequest> }
    > = (props) => {
        const { data } = props ?? {};

        return bulkSetDeviceOperationalStatus(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type BulkSetDeviceOperationalStatusMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useBulkSetDeviceOperationalStatusHook>>
    >
>;
export type BulkSetDeviceOperationalStatusMutationBody =
    | BodyType<BulkSetOperationalStatusRequest>
    | undefined;
export type BulkSetDeviceOperationalStatusMutationError = ErrorType<unknown>;

export const useBulkSetDeviceOperationalStatus = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useBulkSetDeviceOperationalStatusHook>
                >
            >,
            TError,
            { data?: BodyType<BulkSetOperationalStatusRequest> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof useBulkSetDeviceOperationalStatusHook>>
    >,
    TError,
    { data?: BodyType<BulkSetOperationalStatusRequest> },
    TContext
> => {
    return useMutation(
        useBulkSetDeviceOperationalStatusMutationOptions(options),
        queryClient,
    );
};
/**
 * Get device authorization. Requires device_passthrough_manage permission.
 */
export const useDeviceAuthorizationGetHook = () => {
    const deviceAuthorizationGet =
        useCustomFetchClient<DeviceAuthorizationDto>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceAuthorizationGet({
                url: `/devices/${deviceIdentity}/authorization`,
                method: "GET",
                signal,
            });
        },
        [deviceAuthorizationGet],
    );
};

export const getDeviceAuthorizationGetQueryKey = (deviceIdentity: string) => {
    return [`/devices/${deviceIdentity}/authorization`] as const;
};

export const useDeviceAuthorizationGetQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceAuthorizationGetQueryKey(deviceIdentity);

    const deviceAuthorizationGet = useDeviceAuthorizationGetHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>>
    > = ({ signal }) => deviceAuthorizationGet(deviceIdentity, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceAuthorizationGetQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>>
>;
export type DeviceAuthorizationGetQueryError = ErrorType<unknown>;

export function useDeviceAuthorizationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceAuthorizationGetHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceAuthorizationGetHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceAuthorizationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceAuthorizationGetHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceAuthorizationGetHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceAuthorizationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceAuthorizationGet<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceAuthorizationGetHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceAuthorizationGetQueryOptions(
        deviceIdentity,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update device authorization mode and key. Requires device_passthrough_manage permission.
 */
export const useDeviceAuthorizationUpdateHook = () => {
    const deviceAuthorizationUpdate = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            updateDeviceAuthorizationRequest?: BodyType<UpdateDeviceAuthorizationRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceAuthorizationUpdate({
                url: `/devices/${deviceIdentity}/authorization`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: updateDeviceAuthorizationRequest,
                signal,
            });
        },
        [deviceAuthorizationUpdate],
    );
};

export const useDeviceAuthorizationUpdateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceAuthorizationUpdateHook>>
        >,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<UpdateDeviceAuthorizationRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceAuthorizationUpdateHook>>>,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<UpdateDeviceAuthorizationRequest>;
    },
    TContext
> => {
    const mutationKey = ["deviceAuthorizationUpdate"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceAuthorizationUpdate = useDeviceAuthorizationUpdateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceAuthorizationUpdateHook>>
        >,
        {
            deviceIdentity: string;
            data?: BodyType<UpdateDeviceAuthorizationRequest>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceAuthorizationUpdate(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceAuthorizationUpdateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceAuthorizationUpdateHook>>>
>;
export type DeviceAuthorizationUpdateMutationBody =
    | BodyType<UpdateDeviceAuthorizationRequest>
    | undefined;
export type DeviceAuthorizationUpdateMutationError = ErrorType<unknown>;

export const useDeviceAuthorizationUpdate = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceAuthorizationUpdateHook>>
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<UpdateDeviceAuthorizationRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceAuthorizationUpdateHook>>>,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<UpdateDeviceAuthorizationRequest>;
    },
    TContext
> => {
    return useMutation(
        useDeviceAuthorizationUpdateMutationOptions(options),
        queryClient,
    );
};
/**
 * Create a virtual child device for a real device (only if one doesn't already exist). Updates the real device's ChargePointMetadata.ManagedBy, and soft resets the device. Requires Permission.device_passthrough_manage
 */
export const useCreatePassthroughChildDeviceHook = () => {
    const createPassthroughChildDevice = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            createPassthroughChildDeviceRequest?: BodyType<CreatePassthroughChildDeviceRequest>,
            signal?: AbortSignal,
        ) => {
            return createPassthroughChildDevice({
                url: `/devices/${deviceIdentity}/create-passthrough`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: createPassthroughChildDeviceRequest,
                signal,
            });
        },
        [createPassthroughChildDevice],
    );
};

export const useCreatePassthroughChildDeviceMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useCreatePassthroughChildDeviceHook>>
        >,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<CreatePassthroughChildDeviceRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreatePassthroughChildDeviceHook>>>,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<CreatePassthroughChildDeviceRequest>;
    },
    TContext
> => {
    const mutationKey = ["createPassthroughChildDevice"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createPassthroughChildDevice = useCreatePassthroughChildDeviceHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useCreatePassthroughChildDeviceHook>>
        >,
        {
            deviceIdentity: string;
            data?: BodyType<CreatePassthroughChildDeviceRequest>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return createPassthroughChildDevice(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreatePassthroughChildDeviceMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreatePassthroughChildDeviceHook>>>
>;
export type CreatePassthroughChildDeviceMutationBody =
    | BodyType<CreatePassthroughChildDeviceRequest>
    | undefined;
export type CreatePassthroughChildDeviceMutationError = ErrorType<unknown>;

export const useCreatePassthroughChildDevice = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useCreatePassthroughChildDeviceHook>
                >
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<CreatePassthroughChildDeviceRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreatePassthroughChildDeviceHook>>>,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<CreatePassthroughChildDeviceRequest>;
    },
    TContext
> => {
    return useMutation(
        useCreatePassthroughChildDeviceMutationOptions(options),
        queryClient,
    );
};
/**
 * Set/remove a real device as a readonly passthrough. Updates the real device's ReadonlyPassthroughConfig, Auth, ChargePointMetadata.ManagedBy, and soft resets the device. Use PassthroughConfigId=0 to remove a readonly passthrough. Requires Permission.device_passthrough_manage
 */
export const useSetReadonlyPassthroughDeviceHook = () => {
    const setReadonlyPassthroughDevice = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            createPassthroughChildDeviceRequest?: BodyType<CreatePassthroughChildDeviceRequest>,
            signal?: AbortSignal,
        ) => {
            return setReadonlyPassthroughDevice({
                url: `/devices/${deviceIdentity}/set-readonly-passthrough`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: createPassthroughChildDeviceRequest,
                signal,
            });
        },
        [setReadonlyPassthroughDevice],
    );
};

export const useSetReadonlyPassthroughDeviceMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useSetReadonlyPassthroughDeviceHook>>
        >,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<CreatePassthroughChildDeviceRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSetReadonlyPassthroughDeviceHook>>>,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<CreatePassthroughChildDeviceRequest>;
    },
    TContext
> => {
    const mutationKey = ["setReadonlyPassthroughDevice"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const setReadonlyPassthroughDevice = useSetReadonlyPassthroughDeviceHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useSetReadonlyPassthroughDeviceHook>>
        >,
        {
            deviceIdentity: string;
            data?: BodyType<CreatePassthroughChildDeviceRequest>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return setReadonlyPassthroughDevice(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetReadonlyPassthroughDeviceMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSetReadonlyPassthroughDeviceHook>>>
>;
export type SetReadonlyPassthroughDeviceMutationBody =
    | BodyType<CreatePassthroughChildDeviceRequest>
    | undefined;
export type SetReadonlyPassthroughDeviceMutationError = ErrorType<unknown>;

export const useSetReadonlyPassthroughDevice = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useSetReadonlyPassthroughDeviceHook>
                >
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<CreatePassthroughChildDeviceRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSetReadonlyPassthroughDeviceHook>>>,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<CreatePassthroughChildDeviceRequest>;
    },
    TContext
> => {
    return useMutation(
        useSetReadonlyPassthroughDeviceMutationOptions(options),
        queryClient,
    );
};
/**
 * An OData endpoint that lists PayMate Session Information.
 */
export const usePayMateSessionListODataHook = () => {
    const payMateSessionListOData =
        useCustomFetchClient<PayMateTransactionDto[]>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return payMateSessionListOData({
                url: `/devices/${deviceIdentity}/paymate-sessions`,
                method: "GET",
                signal,
            });
        },
        [payMateSessionListOData],
    );
};

export const getPayMateSessionListODataQueryKey = (deviceIdentity: string) => {
    return [`/devices/${deviceIdentity}/paymate-sessions`] as const;
};

export const usePayMateSessionListODataQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof usePayMateSessionListODataHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getPayMateSessionListODataQueryKey(deviceIdentity);

    const payMateSessionListOData = usePayMateSessionListODataHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>>
    > = ({ signal }) => payMateSessionListOData(deviceIdentity, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PayMateSessionListODataQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>>
>;
export type PayMateSessionListODataQueryError = ErrorType<unknown>;

export function usePayMateSessionListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof usePayMateSessionListODataHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof usePayMateSessionListODataHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof usePayMateSessionListODataHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePayMateSessionListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof usePayMateSessionListODataHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof usePayMateSessionListODataHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof usePayMateSessionListODataHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePayMateSessionListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof usePayMateSessionListODataHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePayMateSessionListOData<
    TData = Awaited<
        ReturnType<ReturnType<typeof usePayMateSessionListODataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof usePayMateSessionListODataHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = usePayMateSessionListODataQueryOptions(
        deviceIdentity,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get the uptimes for a specified device. Will default to last 30 days if date range not specified.
New improved calculation method. Returns two uptime values: one that includes periods spent offline as 'up' estimation and
another that excludes offline periods from the 'up' estimation.
Only applicable to devices with connectors.
 */
export const useDeviceUptimeHook = () => {
    const deviceUptime = useCustomFetchClient<DeviceUptimeResponse>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceUptimeParams,
            signal?: AbortSignal,
        ) => {
            return deviceUptime({
                url: `/devices/${deviceIdentity}/uptime`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceUptime],
    );
};

export const getDeviceUptimeQueryKey = (
    deviceIdentity: string,
    params?: DeviceUptimeParams,
) => {
    return [
        `/devices/${deviceIdentity}/uptime`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceUptimeQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceUptimeQueryKey(deviceIdentity, params);

    const deviceUptime = useDeviceUptimeHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>
    > = ({ signal }) => deviceUptime(deviceIdentity, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceUptimeQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>
>;
export type DeviceUptimeQueryError = ErrorType<unknown>;

export function useDeviceUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params: undefined | DeviceUptimeParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useDeviceUptimeHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceUptimeQueryOptions(
        deviceIdentity,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Set maintenance status for a device. Admin only.
 */
export const useInsertDeviceMaintenanceStatusHook = () => {
    const insertDeviceMaintenanceStatus = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            insertDeviceMaintenanceStatusRequest?: BodyType<InsertDeviceMaintenanceStatusRequest>,
            signal?: AbortSignal,
        ) => {
            return insertDeviceMaintenanceStatus({
                url: `/devices/${deviceIdentity}/maintenance-status`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: insertDeviceMaintenanceStatusRequest,
                signal,
            });
        },
        [insertDeviceMaintenanceStatus],
    );
};

export const useInsertDeviceMaintenanceStatusMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useInsertDeviceMaintenanceStatusHook>>
        >,
        TError,
        {
            deviceIdentity: string;
            data?: BodyType<InsertDeviceMaintenanceStatusRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof useInsertDeviceMaintenanceStatusHook>>
    >,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<InsertDeviceMaintenanceStatusRequest>;
    },
    TContext
> => {
    const mutationKey = ["insertDeviceMaintenanceStatus"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const insertDeviceMaintenanceStatus =
        useInsertDeviceMaintenanceStatusHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useInsertDeviceMaintenanceStatusHook>>
        >,
        {
            deviceIdentity: string;
            data?: BodyType<InsertDeviceMaintenanceStatusRequest>;
        }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return insertDeviceMaintenanceStatus(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type InsertDeviceMaintenanceStatusMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useInsertDeviceMaintenanceStatusHook>>>
>;
export type InsertDeviceMaintenanceStatusMutationBody =
    | BodyType<InsertDeviceMaintenanceStatusRequest>
    | undefined;
export type InsertDeviceMaintenanceStatusMutationError = ErrorType<unknown>;

export const useInsertDeviceMaintenanceStatus = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useInsertDeviceMaintenanceStatusHook>
                >
            >,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<InsertDeviceMaintenanceStatusRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof useInsertDeviceMaintenanceStatusHook>>
    >,
    TError,
    {
        deviceIdentity: string;
        data?: BodyType<InsertDeviceMaintenanceStatusRequest>;
    },
    TContext
> => {
    return useMutation(
        useInsertDeviceMaintenanceStatusMutationOptions(options),
        queryClient,
    );
};
/**
 * Get maintenance status logs for a device (IlluminateAdmin or JETChargeStaff users only)
 */
export const useDeviceMaintenanceStatusLogsOdataHook = () => {
    const deviceMaintenanceStatusLogsOdata =
        useCustomFetchClient<DeviceMaintenanceStatusLogDto[]>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceMaintenanceStatusLogsOdata({
                url: `/devices/${deviceIdentity}/maintenance-status-odata`,
                method: "GET",
                signal,
            });
        },
        [deviceMaintenanceStatusLogsOdata],
    );
};

export const getDeviceMaintenanceStatusLogsOdataQueryKey = (
    deviceIdentity: string,
) => {
    return [`/devices/${deviceIdentity}/maintenance-status-odata`] as const;
};

export const useDeviceMaintenanceStatusLogsOdataQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceMaintenanceStatusLogsOdataHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceMaintenanceStatusLogsOdataQueryKey(deviceIdentity);

    const deviceMaintenanceStatusLogsOdata =
        useDeviceMaintenanceStatusLogsOdataHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>
            >
        >
    > = ({ signal }) =>
        deviceMaintenanceStatusLogsOdata(deviceIdentity, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceMaintenanceStatusLogsOdataQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>>
    >
>;
export type DeviceMaintenanceStatusLogsOdataQueryError = ErrorType<unknown>;

export function useDeviceMaintenanceStatusLogsOdata<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceMaintenanceStatusLogsOdataHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceMaintenanceStatusLogsOdataHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceMaintenanceStatusLogsOdataHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceMaintenanceStatusLogsOdata<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceMaintenanceStatusLogsOdataHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceMaintenanceStatusLogsOdataHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useDeviceMaintenanceStatusLogsOdataHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceMaintenanceStatusLogsOdata<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceMaintenanceStatusLogsOdataHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceMaintenanceStatusLogsOdata<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceMaintenanceStatusLogsOdataHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useDeviceMaintenanceStatusLogsOdataHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceMaintenanceStatusLogsOdataQueryOptions(
        deviceIdentity,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get list of connector uptimes for a specified device. Will default to last 30 days if date range not specified.
 */
export const useDeviceConnectorUptimeHook = () => {
    const deviceConnectorUptime =
        useCustomFetchClient<DeviceConnectorUptimeResponse[]>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceConnectorUptimeParams,
            signal?: AbortSignal,
        ) => {
            return deviceConnectorUptime({
                url: `/devices/${deviceIdentity}/connector-uptime`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceConnectorUptime],
    );
};

export const getDeviceConnectorUptimeQueryKey = (
    deviceIdentity: string,
    params?: DeviceConnectorUptimeParams,
) => {
    return [
        `/devices/${deviceIdentity}/connector-uptime`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceConnectorUptimeQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceConnectorUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceConnectorUptimeQueryKey(deviceIdentity, params);

    const deviceConnectorUptime = useDeviceConnectorUptimeHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>>
    > = ({ signal }) => deviceConnectorUptime(deviceIdentity, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceConnectorUptimeQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>>
>;
export type DeviceConnectorUptimeQueryError = ErrorType<unknown>;

export function useDeviceConnectorUptime<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params: undefined | DeviceConnectorUptimeParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectorUptimeHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectorUptimeHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceConnectorUptime<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceConnectorUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectorUptimeHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectorUptimeHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceConnectorUptime<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceConnectorUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceConnectorUptime<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceConnectorUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceConnectorUptimeHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceConnectorUptimeQueryOptions(
        deviceIdentity,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get the daily uptimes for a specified device. Will default to last 30 days if date range not specified.
 */
export const useDeviceDailyUptimesHook = () => {
    const deviceDailyUptimes = useCustomFetchClient<DeviceUptimeResponse[]>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: DeviceDailyUptimesParams,
            signal?: AbortSignal,
        ) => {
            return deviceDailyUptimes({
                url: `/devices/${deviceIdentity}/daily-uptimes`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceDailyUptimes],
    );
};

export const getDeviceDailyUptimesQueryKey = (
    deviceIdentity: string,
    params?: DeviceDailyUptimesParams,
) => {
    return [
        `/devices/${deviceIdentity}/daily-uptimes`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceDailyUptimesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceDailyUptimesQueryKey(deviceIdentity, params);

    const deviceDailyUptimes = useDeviceDailyUptimesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>
    > = ({ signal }) => deviceDailyUptimes(deviceIdentity, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceIdentity,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceDailyUptimesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>
>;
export type DeviceDailyUptimesQueryError = ErrorType<unknown>;

export function useDeviceDailyUptimes<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params: undefined | DeviceDailyUptimesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceDailyUptimes<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceDailyUptimes<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceDailyUptimes<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceIdentity: string,
    params?: DeviceDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceDailyUptimesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceDailyUptimesQueryOptions(
        deviceIdentity,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Remove a device for e2e automation test purpose ONLY. Requires system_e2e_test_runner permission.
 */
export const useDeviceRemoveHook = () => {
    const deviceRemove = useCustomFetchClient<ApiResult>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceRemove({
                url: `/devices/remove/${deviceIdentity}`,
                method: "DELETE",
                signal,
            });
        },
        [deviceRemove],
    );
};

export const useDeviceRemoveMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceRemoveHook>>>,
        TError,
        { deviceIdentity: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceRemoveHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    const mutationKey = ["deviceRemove"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceRemove = useDeviceRemoveHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceRemoveHook>>>,
        { deviceIdentity: string }
    > = (props) => {
        const { deviceIdentity } = props ?? {};

        return deviceRemove(deviceIdentity);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceRemoveMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceRemoveHook>>>
>;

export type DeviceRemoveMutationError = ErrorType<unknown>;

export const useDeviceRemove = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceRemoveHook>>>,
            TError,
            { deviceIdentity: string },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceRemoveHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    return useMutation(useDeviceRemoveMutationOptions(options), queryClient);
};
/**
 * Set device managedBy in metadata. will update db. Admin only.
 */
export const useDeviceManagedByUpdateHook = () => {
    const deviceManagedByUpdate = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params: DeviceManagedByUpdateParams,
            signal?: AbortSignal,
        ) => {
            return deviceManagedByUpdate({
                url: `/devices/${deviceIdentity}/set-managed-by`,
                method: "PATCH",
                params,
                signal,
            });
        },
        [deviceManagedByUpdate],
    );
};

export const useDeviceManagedByUpdateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceManagedByUpdateHook>>>,
        TError,
        { deviceIdentity: string; params: DeviceManagedByUpdateParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceManagedByUpdateHook>>>,
    TError,
    { deviceIdentity: string; params: DeviceManagedByUpdateParams },
    TContext
> => {
    const mutationKey = ["deviceManagedByUpdate"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceManagedByUpdate = useDeviceManagedByUpdateHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceManagedByUpdateHook>>>,
        { deviceIdentity: string; params: DeviceManagedByUpdateParams }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return deviceManagedByUpdate(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceManagedByUpdateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceManagedByUpdateHook>>>
>;

export type DeviceManagedByUpdateMutationError = ErrorType<unknown>;

export const useDeviceManagedByUpdate = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceManagedByUpdateHook>>
            >,
            TError,
            { deviceIdentity: string; params: DeviceManagedByUpdateParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceManagedByUpdateHook>>>,
    TError,
    { deviceIdentity: string; params: DeviceManagedByUpdateParams },
    TContext
> => {
    return useMutation(
        useDeviceManagedByUpdateMutationOptions(options),
        queryClient,
    );
};
/**
 * Update charger OCPP connection config
 */
export const useUpdateChargerOcppConnectionHook = () => {
    const updateChargerOcppConnection = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params: UpdateChargerOcppConnectionParams,
            signal?: AbortSignal,
        ) => {
            return updateChargerOcppConnection({
                url: `/devices/${deviceIdentity}/update-ocpp-connection`,
                method: "POST",
                params,
                signal,
            });
        },
        [updateChargerOcppConnection],
    );
};

export const useUpdateChargerOcppConnectionMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useUpdateChargerOcppConnectionHook>>
        >,
        TError,
        { deviceIdentity: string; params: UpdateChargerOcppConnectionParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateChargerOcppConnectionHook>>>,
    TError,
    { deviceIdentity: string; params: UpdateChargerOcppConnectionParams },
    TContext
> => {
    const mutationKey = ["updateChargerOcppConnection"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateChargerOcppConnection = useUpdateChargerOcppConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useUpdateChargerOcppConnectionHook>>
        >,
        { deviceIdentity: string; params: UpdateChargerOcppConnectionParams }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return updateChargerOcppConnection(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateChargerOcppConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateChargerOcppConnectionHook>>>
>;

export type UpdateChargerOcppConnectionMutationError = ErrorType<unknown>;

export const useUpdateChargerOcppConnection = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useUpdateChargerOcppConnectionHook>
                >
            >,
            TError,
            {
                deviceIdentity: string;
                params: UpdateChargerOcppConnectionParams;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateChargerOcppConnectionHook>>>,
    TError,
    { deviceIdentity: string; params: UpdateChargerOcppConnectionParams },
    TContext
> => {
    return useMutation(
        useUpdateChargerOcppConnectionMutationOptions(options),
        queryClient,
    );
};
/**
 * Start polling the specified Core device for Snapshot updates. Client must also call signalRHub.invoke('joinGroup', `device_<deviceId>`), and listen to it via `signalRHub.on('coreSnapshotMessage', (message: CoreSnapshotMessage) => {}` to receive messages.
 */
export const useStartPollingCoreSnapshotHook = () => {
    const startPollingCoreSnapshot = useCustomFetchClient<ApiResult>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return startPollingCoreSnapshot({
                url: `/devices/${deviceIdentity}/start-polling-core-snapshot`,
                method: "PUT",
                signal,
            });
        },
        [startPollingCoreSnapshot],
    );
};

export const useStartPollingCoreSnapshotMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useStartPollingCoreSnapshotHook>>>,
        TError,
        { deviceIdentity: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useStartPollingCoreSnapshotHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    const mutationKey = ["startPollingCoreSnapshot"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const startPollingCoreSnapshot = useStartPollingCoreSnapshotHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useStartPollingCoreSnapshotHook>>>,
        { deviceIdentity: string }
    > = (props) => {
        const { deviceIdentity } = props ?? {};

        return startPollingCoreSnapshot(deviceIdentity);
    };

    return { mutationFn, ...mutationOptions };
};

export type StartPollingCoreSnapshotMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useStartPollingCoreSnapshotHook>>>
>;

export type StartPollingCoreSnapshotMutationError = ErrorType<unknown>;

export const useStartPollingCoreSnapshot = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useStartPollingCoreSnapshotHook>>
            >,
            TError,
            { deviceIdentity: string },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useStartPollingCoreSnapshotHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    return useMutation(
        useStartPollingCoreSnapshotMutationOptions(options),
        queryClient,
    );
};
/**
 * Get the connection status for multiple devices.
 */
export const useDeviceConnectionStatusesHook = () => {
    const deviceConnectionStatuses =
        useCustomFetchClient<DeviceConnectionStatusResponse>();

    return useCallback(
        (params: DeviceConnectionStatusesParams, signal?: AbortSignal) => {
            return deviceConnectionStatuses({
                url: `/devices/connection-statuses`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceConnectionStatuses],
    );
};

export const getDeviceConnectionStatusesQueryKey = (
    params?: DeviceConnectionStatusesParams,
) => {
    return [
        `/devices/connection-statuses`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceConnectionStatusesQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: DeviceConnectionStatusesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceConnectionStatusesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getDeviceConnectionStatusesQueryKey(params);

    const deviceConnectionStatuses = useDeviceConnectionStatusesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>>
    > = ({ signal }) => deviceConnectionStatuses(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceConnectionStatusesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>>
>;
export type DeviceConnectionStatusesQueryError = ErrorType<unknown>;

export function useDeviceConnectionStatuses<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: DeviceConnectionStatusesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceConnectionStatusesHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectionStatusesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectionStatusesHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceConnectionStatuses<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: DeviceConnectionStatusesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceConnectionStatusesHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectionStatusesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceConnectionStatusesHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceConnectionStatuses<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: DeviceConnectionStatusesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceConnectionStatusesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceConnectionStatuses<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceConnectionStatusesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: DeviceConnectionStatusesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceConnectionStatusesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceConnectionStatusesQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Decommission a device. Sets DecommissionedAt timestamp and DeviceAuthorizationMode to Reject. Requires system_device_provisioning permission.
 */
export const useDeviceDecommissionHook = () => {
    const deviceDecommission = useCustomFetchClient<ApiResult>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceDecommission({
                url: `/devices/${deviceIdentity}/decommission`,
                method: "POST",
                signal,
            });
        },
        [deviceDecommission],
    );
};

export const useDeviceDecommissionMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceDecommissionHook>>>,
        TError,
        { deviceIdentity: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceDecommissionHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    const mutationKey = ["deviceDecommission"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceDecommission = useDeviceDecommissionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceDecommissionHook>>>,
        { deviceIdentity: string }
    > = (props) => {
        const { deviceIdentity } = props ?? {};

        return deviceDecommission(deviceIdentity);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceDecommissionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceDecommissionHook>>>
>;

export type DeviceDecommissionMutationError = ErrorType<unknown>;

export const useDeviceDecommission = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceDecommissionHook>>>,
            TError,
            { deviceIdentity: string },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceDecommissionHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    return useMutation(
        useDeviceDecommissionMutationOptions(options),
        queryClient,
    );
};
/**
 * Undo decommission of a device. Clears DecommissionedAt timestamp. Validates no other device with same serial number exists. Requires system_device_provisioning permission.
 */
export const useDeviceUndoDecommissionHook = () => {
    const deviceUndoDecommission = useCustomFetchClient<ApiResult>();

    return useCallback(
        (deviceIdentity: string, signal?: AbortSignal) => {
            return deviceUndoDecommission({
                url: `/devices/${deviceIdentity}/undo-decommission`,
                method: "POST",
                signal,
            });
        },
        [deviceUndoDecommission],
    );
};

export const useDeviceUndoDecommissionMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceUndoDecommissionHook>>>,
        TError,
        { deviceIdentity: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceUndoDecommissionHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    const mutationKey = ["deviceUndoDecommission"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceUndoDecommission = useDeviceUndoDecommissionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceUndoDecommissionHook>>>,
        { deviceIdentity: string }
    > = (props) => {
        const { deviceIdentity } = props ?? {};

        return deviceUndoDecommission(deviceIdentity);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceUndoDecommissionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceUndoDecommissionHook>>>
>;

export type DeviceUndoDecommissionMutationError = ErrorType<unknown>;

export const useDeviceUndoDecommission = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceUndoDecommissionHook>>
            >,
            TError,
            { deviceIdentity: string },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceUndoDecommissionHook>>>,
    TError,
    { deviceIdentity: string },
    TContext
> => {
    return useMutation(
        useDeviceUndoDecommissionMutationOptions(options),
        queryClient,
    );
};
/**
 * Set active protocol for a device. Also disables passthroughs if not supported for the set protocol. Flags a device for Reboot.Possible error codes:
9002: Rebooting: Success. Device is now rebooting.
 */
export const useSetDeviceProtocolHook = () => {
    const setDeviceProtocol = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            deviceProtocolUpdateDto?: BodyType<DeviceProtocolUpdateDto>,
            signal?: AbortSignal,
        ) => {
            return setDeviceProtocol({
                url: `/devices/${deviceIdentity}/protocol`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: deviceProtocolUpdateDto,
                signal,
            });
        },
        [setDeviceProtocol],
    );
};

export const useSetDeviceProtocolMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSetDeviceProtocolHook>>>,
        TError,
        { deviceIdentity: string; data?: BodyType<DeviceProtocolUpdateDto> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSetDeviceProtocolHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceProtocolUpdateDto> },
    TContext
> => {
    const mutationKey = ["setDeviceProtocol"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const setDeviceProtocol = useSetDeviceProtocolHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSetDeviceProtocolHook>>>,
        { deviceIdentity: string; data?: BodyType<DeviceProtocolUpdateDto> }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return setDeviceProtocol(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetDeviceProtocolMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSetDeviceProtocolHook>>>
>;
export type SetDeviceProtocolMutationBody =
    | BodyType<DeviceProtocolUpdateDto>
    | undefined;
export type SetDeviceProtocolMutationError = ErrorType<unknown>;

export const useSetDeviceProtocol = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useSetDeviceProtocolHook>>>,
            TError,
            {
                deviceIdentity: string;
                data?: BodyType<DeviceProtocolUpdateDto>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSetDeviceProtocolHook>>>,
    TError,
    { deviceIdentity: string; data?: BodyType<DeviceProtocolUpdateDto> },
    TContext
> => {
    return useMutation(
        useSetDeviceProtocolMutationOptions(options),
        queryClient,
    );
};
/**
 * Temporarily enable auth for decommissioned device to allow reprovisioning. Sets configurable timeout with auto-rollback to Reject mode.
 */
export const usePrepareDeviceForReprovisioningHook = () => {
    const prepareDeviceForReprovisioning = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            params?: PrepareDeviceForReprovisioningParams,
            signal?: AbortSignal,
        ) => {
            return prepareDeviceForReprovisioning({
                url: `/devices/${deviceIdentity}/prepare-for-reprovisioning`,
                method: "POST",
                params,
                signal,
            });
        },
        [prepareDeviceForReprovisioning],
    );
};

export const usePrepareDeviceForReprovisioningMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePrepareDeviceForReprovisioningHook>>
        >,
        TError,
        {
            deviceIdentity: string;
            params?: PrepareDeviceForReprovisioningParams;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePrepareDeviceForReprovisioningHook>>
    >,
    TError,
    { deviceIdentity: string; params?: PrepareDeviceForReprovisioningParams },
    TContext
> => {
    const mutationKey = ["prepareDeviceForReprovisioning"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const prepareDeviceForReprovisioning =
        usePrepareDeviceForReprovisioningHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePrepareDeviceForReprovisioningHook>>
        >,
        {
            deviceIdentity: string;
            params?: PrepareDeviceForReprovisioningParams;
        }
    > = (props) => {
        const { deviceIdentity, params } = props ?? {};

        return prepareDeviceForReprovisioning(deviceIdentity, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PrepareDeviceForReprovisioningMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePrepareDeviceForReprovisioningHook>>
    >
>;

export type PrepareDeviceForReprovisioningMutationError = ErrorType<unknown>;

export const usePrepareDeviceForReprovisioning = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePrepareDeviceForReprovisioningHook>
                >
            >,
            TError,
            {
                deviceIdentity: string;
                params?: PrepareDeviceForReprovisioningParams;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePrepareDeviceForReprovisioningHook>>
    >,
    TError,
    { deviceIdentity: string; params?: PrepareDeviceForReprovisioningParams },
    TContext
> => {
    return useMutation(
        usePrepareDeviceForReprovisioningMutationOptions(options),
        queryClient,
    );
};
/**
 * Complete device reprovisioning by creating new device and updating existing device's OCPP endpoint. Requires existing device to be online and in reprovisioning state.
 */
export const useReprovisionDeviceHook = () => {
    const reprovisionDevice = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            existingDeviceIdentity: string,
            reprovisionDeviceRequest: BodyType<ReprovisionDeviceRequest>,
            signal?: AbortSignal,
        ) => {
            return reprovisionDevice({
                url: `/devices/${existingDeviceIdentity}/reprovision`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: reprovisionDeviceRequest,
                signal,
            });
        },
        [reprovisionDevice],
    );
};

export const useReprovisionDeviceMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useReprovisionDeviceHook>>>,
        TError,
        {
            existingDeviceIdentity: string;
            data: BodyType<ReprovisionDeviceRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReprovisionDeviceHook>>>,
    TError,
    {
        existingDeviceIdentity: string;
        data: BodyType<ReprovisionDeviceRequest>;
    },
    TContext
> => {
    const mutationKey = ["reprovisionDevice"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const reprovisionDevice = useReprovisionDeviceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useReprovisionDeviceHook>>>,
        {
            existingDeviceIdentity: string;
            data: BodyType<ReprovisionDeviceRequest>;
        }
    > = (props) => {
        const { existingDeviceIdentity, data } = props ?? {};

        return reprovisionDevice(existingDeviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ReprovisionDeviceMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useReprovisionDeviceHook>>>
>;
export type ReprovisionDeviceMutationBody = BodyType<ReprovisionDeviceRequest>;
export type ReprovisionDeviceMutationError = ErrorType<unknown>;

export const useReprovisionDevice = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useReprovisionDeviceHook>>>,
            TError,
            {
                existingDeviceIdentity: string;
                data: BodyType<ReprovisionDeviceRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useReprovisionDeviceHook>>>,
    TError,
    {
        existingDeviceIdentity: string;
        data: BodyType<ReprovisionDeviceRequest>;
    },
    TContext
> => {
    return useMutation(
        useReprovisionDeviceMutationOptions(options),
        queryClient,
    );
};
/**
 * Validate if user can create new devices (has permission, Vendor has not exceeded provisioning limit, etc). Optionally provide a new device identity to check if that is valid and available (this checks across all orgs in system).
 */
export const useValidateNewDeviceHook = () => {
    const validateNewDevice = useCustomFetchClient<ApiResult>();

    return useCallback(
        (params?: ValidateNewDeviceParams, signal?: AbortSignal) => {
            return validateNewDevice({
                url: `/validate-new-device`,
                method: "GET",
                params,
                signal,
            });
        },
        [validateNewDevice],
    );
};

export const getValidateNewDeviceQueryKey = (
    params?: ValidateNewDeviceParams,
) => {
    return [`/validate-new-device`, ...(params ? [params] : [])] as const;
};

export const useValidateNewDeviceQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ValidateNewDeviceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getValidateNewDeviceQueryKey(params);

    const validateNewDevice = useValidateNewDeviceHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>
    > = ({ signal }) => validateNewDevice(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ValidateNewDeviceQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>
>;
export type ValidateNewDeviceQueryError = ErrorType<unknown>;

export function useValidateNewDevice<
    TData = Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>,
    TError = ErrorType<unknown>,
>(
    params: undefined | ValidateNewDeviceParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useValidateNewDevice<
    TData = Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ValidateNewDeviceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useValidateNewDevice<
    TData = Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ValidateNewDeviceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useValidateNewDevice<
    TData = Awaited<ReturnType<ReturnType<typeof useValidateNewDeviceHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ValidateNewDeviceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useValidateNewDeviceHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useValidateNewDeviceQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Edit device connector details.
 */
export const useDeviceConnectorEditHook = () => {
    const deviceConnectorEdit = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceIdentity: string,
            connectorDto: BodyType<ConnectorDto>,
            signal?: AbortSignal,
        ) => {
            return deviceConnectorEdit({
                url: `/devices/${deviceIdentity}/connectors`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: connectorDto,
                signal,
            });
        },
        [deviceConnectorEdit],
    );
};

export const useDeviceConnectorEditMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceConnectorEditHook>>>,
        TError,
        { deviceIdentity: string; data: BodyType<ConnectorDto> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceConnectorEditHook>>>,
    TError,
    { deviceIdentity: string; data: BodyType<ConnectorDto> },
    TContext
> => {
    const mutationKey = ["deviceConnectorEdit"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceConnectorEdit = useDeviceConnectorEditHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceConnectorEditHook>>>,
        { deviceIdentity: string; data: BodyType<ConnectorDto> }
    > = (props) => {
        const { deviceIdentity, data } = props ?? {};

        return deviceConnectorEdit(deviceIdentity, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceConnectorEditMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceConnectorEditHook>>>
>;
export type DeviceConnectorEditMutationBody = BodyType<ConnectorDto>;
export type DeviceConnectorEditMutationError = ErrorType<unknown>;

export const useDeviceConnectorEdit = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceConnectorEditHook>>>,
            TError,
            { deviceIdentity: string; data: BodyType<ConnectorDto> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceConnectorEditHook>>>,
    TError,
    { deviceIdentity: string; data: BodyType<ConnectorDto> },
    TContext
> => {
    return useMutation(
        useDeviceConnectorEditMutationOptions(options),
        queryClient,
    );
};
